export enum CallRole {
  Scheduler = 1,
  Attendee,
}